
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.333 20.833c-2.083 0-4.083-.333-5.95-.95a1.7 1.7 0 00-1.7.4l-3.666 3.667A25.124 25.124 0 016.033 12.983L9.7 9.3c.467-.45.6-1.1.417-1.683a18.934 18.934 0 01-.95-5.95C9.167.75 8.417 0 7.5 0H1.667C.75 0 0 .75 0 1.667 0 17.317 12.683 30 28.333 30 29.25 30 30 29.25 30 28.333V22.5c0-.917-.75-1.667-1.667-1.667h0z","stroke":"#FFF","fill":"#000","fill-rule":"evenodd","fill-opacity":".7"}})])
          )
        }
      }
    